import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = localStorage.getItem('authToken');
    return !!token; // true if token exists 
  });
  const navigate = useNavigate();

  useEffect(() => {
  }, [isAuthenticated]);

  const login = () => {
    sessionStorage.setItem('isAuthenticated', 'true');
    setIsAuthenticated(true);
  };

  const edit_profile = () => {
    if (!isAuthenticated) {
      // If not authenticated, redirect to login or another appropriate page
      navigate('/login');
    } else {
      // If authenticated, perform the action and navigate
      navigate('/edit-detail');
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userid');
    setIsAuthenticated(false);
    navigate('/login'); 
  };

  useEffect(() => {

    const handleStorageChange = (e) => {
      if (e.key === 'authToken' && e.newValue === null) {
        setIsAuthenticated(false);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);

  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, edit_profile, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
